import React from 'react';
import Reflux from 'reflux';
import AutocompleteInput from './AutocompleteInput';
import RcIf from 'rc-if';
import ReactTooltip from 'react-tooltip';
import AppStore from '../../AppStore';

const optionsStructure = [
    {
        position: 1
    }, {
        position: 2
    }, {
        position: 3
    }, {
        position: 4
    }, {
        position: 5
    }
];

export default class TopBox extends Reflux.Component {
    constructor (props) {
        super(props);
        let options = optionsStructure;
        if (props.options && props.options.length > 0) {
            options = props.options;
        }
        this.state = {
            options: options,
            classOption: [],
            globalOption: ['globalOption1', 'globalOption2', 'globalOption3', 'globalOption4', 'globalOption5'],
            topic: props.topic || '',
            enableEditing: this.props.enableEditing || false
        };
        this.store = AppStore;
    }
    searchPosition (position, newProps) {
        let option = newProps.options.find((newOption) => {
            return parseInt(newOption.position) === parseInt(position);
        });
        return option;
    }
    componentWillReceiveProps (newProps) {
        if (newProps.options && newProps.options.length > 0) {
            let options = optionsStructure;
            options = options.sort((a, b) => {
                if (a.position > b.position) {
                    return b;
                }
            });
            options = options.map((option) => {
                const newOption = this.searchPosition(option.position, newProps);
                if (newOption) {
                    option = newOption;
                }
                return option;
            });
            this.setState({options: options});
        } else {
            this.setState({options: optionsStructure});
        }
        if (newProps.topic) {
            this.setState({topic: newProps.topic});
        }
        this.setState({enableEditing: newProps.enableEditing});
    }
    completeSentence (option) {
        if (!option.sentence) {
            option.sentence = '';
        }
        return option;
    }
    moveOptionDown = (option) => {
        let initialIndex = parseInt(option.position);
        let finalIndex = initialIndex + 1;
        let options = this.state.options;
        if (finalIndex > 5) {
            return;
        }
        let firstOption = options[initialIndex - 1];
        firstOption.position = finalIndex.toString();
        firstOption.position = parseInt(firstOption.position);
        let secondOption = options[finalIndex - 1];
        secondOption.position = initialIndex.toString();
        secondOption.position = parseInt(secondOption.position);
        options[initialIndex - 1] = this.completeSentence(secondOption);
        options[finalIndex - 1] = this.completeSentence(firstOption);
        this.setState({options});
    }
    moveOptionUp = (option) => {
        let initialIndex = parseInt(option.position);
        let finalIndex = initialIndex - 1;
        let options = this.state.options;
        if (finalIndex < 1) {
            return;
        }
        let firstOption = options[initialIndex - 1];
        firstOption.position = finalIndex.toString();
        firstOption.position = parseInt(firstOption.position);
        let secondOption = options[finalIndex - 1];
        secondOption.position = initialIndex.toString();
        secondOption.position = parseInt(secondOption.position);
        options[initialIndex - 1] = this.completeSentence(secondOption);
        options[finalIndex - 1] = this.completeSentence(firstOption);
        this.setState({options});
    }
    render () {
        return (
          <div className='topcards'>
            <ul className='options'>
              {this.state.options.map((option, index) => {
                  return (
                    <li key={index} className={this.state.classOption[option.position - 1]}>
                      <div className={'option-content relative optionTop' + option.position}>
                        <span className={'numberTop ' + (this.props.isGlobal ? 'globalNumber' : '')}>{option.position}</span>
                        <i className='fa fa-arrow-left back-option' aria-hidden='true' />
                        <AutocompleteInput option={option} optionIndex={index} topic={this.state.topic} enableEditing={this.state.enableEditing} />
                        <RcIf if={this.state.enableEditing}>
                          <div className='arrow-edit'>
                            <RcIf if={index > 0}>
                              <button className='up-edit' onClick={(e) => { this.moveOptionUp(option); }} data-tip='Subir un puesto' data-for='up-top' />
                              <ReactTooltip place='left' type='dark' effect='solid' id='up-top' />
                            </RcIf>
                            <RcIf if={index < 4}>
                              <button className='down-edit' onClick={(e) => { this.moveOptionDown(option); }} data-tip='Bajar un puesto' data-for='down-top' />
                              <ReactTooltip place='left' type='dark' effect='solid' id='down-top' />
                            </RcIf>
                          </div>
                        </RcIf>
                      </div>
                    </li>
                  );
              })}
            </ul>
          </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/topic/TopBox.js